import React, { useState } from 'react'
import {
  NavWrapper,
  TableTop,
  StyledP,
  StyledDiv,
} from 'modules/Roles/Partials/RolesInfoTable/Style/style'
import SearchInput from 'components/SearchInput'
import { FilterText } from 'components/FilterDiv'
import RoleFilter from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleFilter'
import ActionsRole from 'modules/Roles/Partials/RolesInfoTable/Partials/ActionsRole'
import { StyledTable } from 'components/TableStyles/TableStyles'
import RoleStatus from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleStatus'
import RoleDetails from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleDetails'
import HeartOutLine from 'components/icons/HeartOutLine'
import HeartFilled from 'components/icons/HeartFilled'
import { Space } from 'antd'
import moment from 'moment'
import { formatNumber } from 'utils/formatNumber'
import { useSelector } from 'react-redux'

const RolesInfoTable = ({
  rolesList,
  updateRoleData,
  setJobId,
  setUrl,
  currentUrl,
  setCurrentPage,
  currentPage,
  getJobDetails,
  corporateAboutUs,
  onAcceptOrRejectClick,
  onSortValueChanged,
  loading = false,
  citiesList,
  getCities,
  cruds,
  onAcceptOrRejectRole,
  setEventId,
  ScrollRef,
  selectionType,
  urlQuery,
}) => {
  const instituteData = useSelector(state => state.auth.instituteDetails)
  const [search, setSearch] = useState('')
  const [debounced, setDebounced] = useState(() => search)

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(search)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  React.useEffect(() => {
    if (search) {
      setUrl(`searchBy=${search.trim()}`)
    } else {
      setUrl('')
    }
    setCurrentPage(0)
  }, [debounced])
  const getMaxCTC = role => {
    if (role?.maxCompensation == '0' && role?.minCompensation == '0') {
      return 'No Stipend'
    }
    if (role?.CTCIsTierBased) {
      let tier = instituteData?.tier
      let obj = role?.CTC.find(val => {
        return val.name == `tier${tier}`
      })
      if (obj) {
        if (obj?.isRange) {
          return `₹${formatNumber(+obj?.min)} - ₹${formatNumber(+obj?.max)}`
        }
        return `₹${formatNumber(+obj?.max)}`
      }
      return `₹${formatNumber(+role?.maxCompensation)}`
    }
    if (role?.minCompensation == role?.maxCompensation) {
      return `₹${formatNumber(+role?.maxCompensation)}`
    } else {
      return `₹${formatNumber(+role?.minCompensation)} - ${formatNumber(
        +role?.maxCompensation
      )}`
    }
  }
  const columns = [
    {
      title: 'Job Details',
      dataIndex: '',
      key: 'tittle',
      sorter: true,
      width: '45%',
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => <RoleDetails data={data?.jobRoles} />,
    },
    {
      title: 'Salary',
      dataIndex: 'maxCompensation',
      sorter: true,
      key: 'maxCompensation',
      sortDirections: ['ascend', 'descend'],
      render: (text, item) => {
        const ctc = getMaxCTC(item?.jobRoles)
        return (
          <StyledP>
            {ctc}
            {ctc !== 'No Stipend' && (
              <>
                {' Per'}
                {item?.jobRoles?.CTCPeriod == 'ANNUALLY' ? ' annum' : ' month'}
              </>
            )}
          </StyledP>
        )
      },
    },
    {
      title: 'Time',
      dataIndex: 'postedDate',
      sorter: true,
      key: 'postedDate',
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => (
        <StyledDiv>
          {moment(data?.jobRoles?.postedDate).fromNow(true)} ago
        </StyledDiv>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => <RoleStatus status={data?.status || 0} />,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      render: (id, data) => (
        <Space>
          {data?.saved == 1 ? (
            <HeartFilled
              onClick={() => {
                saveRole(data)
              }}
            />
          ) : (
            <HeartOutLine
              onClick={() => {
                saveRole(data)
              }}
            />
          )}

          <ActionsRole
            data={data}
            setJobId={setJobId}
            getJobDetails={getJobDetails}
            corporateAboutUs={corporateAboutUs}
            onAcceptOrRejectClick={onAcceptOrRejectClick}
            cruds={cruds}
            onAcceptOrRejectRole={onAcceptOrRejectRole}
            setEventId={setEventId}
          />
        </Space>
      ),
    },
  ].filter(item => !item.hidden)

  const saveRole = data => {
    let payLoad = {
      id: data?.jobRoles?.id,
      saved: data?.saved == 1 ? '0' : '1',
    }
    updateRoleData(payLoad)
  }
  const paginationChange = (page, pageSize) => {
    setUrl(`${currentUrl}`)
    setCurrentPage(page - 1)
  }

  const handleSorting = (pagination, filter, sorter) => {
    const sortKey = sorter?.order
      ? sorter?.columnKey
        ? sorter?.columnKey === 'specialization'
          ? 'stream'
          : sorter?.columnKey
        : ''
      : ''

    const sortOrder = sorter?.order
      ? sorter?.order === 'ascend'
        ? 'asc'
        : 'desc'
      : ''
      const sortOrderDate = sorter?.order
      ? sorter?.order === 'ascend'
        ? 'desc'
        :  'asc'
      : ''
    onSortValueChanged(
      sortKey === '' ? '' : `sort=${sortKey}&orderBy=${sorter?.columnKey === "postedDate" ? sortOrderDate :  sortOrder}`
    )
  }

  const changeFilters = filter => {
    setUrl(`${filter}`)
    setCurrentPage(0)
  }
  return (
    <NavWrapper column>
      <TableTop centerVertically>
        <SearchInput
          width={'25%'}
          placeholder="Search by role name"
          bordered={false}
          setSearchValue={text => {
            setSearch(text)
          }}
        />
        <RoleFilter
          setQuery={changeFilters}
          citiesList={citiesList}
          getCities={getCities}
          selectionType={selectionType}
          urlQuery={urlQuery}
        />
        <FilterText>
          Showing {10 * currentPage + rolesList?.result?.length} of{' '}
          {rolesList?.count}
        </FilterText>
      </TableTop>
      <StyledTable
        columns={columns}
        loading={loading}
        dataSource={rolesList?.result}
        onChange={handleSorting}
        pagination={{
          showSizeChanger: false,
          defaultPageSize: 10,
          current: currentPage + 1,
          onChange: (page, pageSize) => {
            paginationChange(page, pageSize)
            ScrollRef()
          },
          total: rolesList?.count,
        }}
      />
    </NavWrapper>
  )
}

export default RolesInfoTable
